// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"194":"menuitems","231":"checkout","496":"landingpages","576":"mainpages"}[chunkId] + "." + {"194":"6c7f731f","231":"92734087","496":"eaa81404","576":"6cffee01"}[chunkId] + ".css";
};